import { render, staticRenderFns } from "./MessagingSafety.vue?vue&type=template&id=1aad8d61&scoped=true"
import script from "./MessagingSafety.vue?vue&type=script&lang=js"
export * from "./MessagingSafety.vue?vue&type=script&lang=js"
import style0 from "./MessagingSafety.vue?vue&type=style&index=0&id=1aad8d61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad8d61",
  null
  
)

export default component.exports